import React from 'react'
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import SoftTypography from "components/SoftTypography";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import { useEffect, useState } from "react";
import CustomTabs from "../components/CustomTabs";
import { Snackbar } from "@mui/material";
import Changelogs from "./components/changelogs"

const index = () => {
    const [open, setOpen] = useState(false);
    const [changelog,setChangelog] = useState([]);
    const AppService = useAppServices();


    const GetChangelogs = async () => {
           const { response } = await AppService.changelogs.Get()
           if(response){
               setChangelog(response?.data)
           }
    }

    useEffect(() => {
     GetChangelogs();
    },[])



    const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };


  const tabsData = [
      { label: "Added", content: <Changelogs data={changelog} type={"added"}/> },
      { label: "Updated", content: <Changelogs data={changelog} type={"updated"}/> },
      { label: "Fixed", content: <Changelogs data={changelog} type={"fixed"}/> },
      { label: "Removed", content: <Changelogs data={changelog} type={"removed"}/> },
    ];


  return (
    <PageLayout>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            message="Theme Updated Successfully"
            action={[]}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          />
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <SoftBox className="d-flex " style={{ justifyContent: "space-between" }}>
                <SoftTypography
                  variant={"h2"}
                  textTransform="capitalize"
                  fontWeight="600"
                >
                  Changelogs
                </SoftTypography>
                {/* {!agency?.auto_configure && (
                  <button
                    onClick={handleAutoConfigure}
                    className="btn-new-design-black-addacount font-16"
                    style={{
                      margin: "0px 0px 0px 10px",
                      padding: "10px 20px",
                      border: "green",
                      color: "green",
                    }}
                    type="submit"
                    variant="outlined"
                    color={"dark"}
                    size="small"
                  >
                    Auto Configure
                  </button>
                )} */}
              </SoftBox>
            </Grid>
            <Grid item xs={12}>
              <SoftBox display="flex-col" justifyContent="space-between" alignItems="center">
                <CustomTabs tabsData={tabsData} />
              </SoftBox>
            </Grid>
          </Grid>
        </PageLayout>
  )
}

export default index